module.exports = __webpack_public_path__ + "3ad9557d21dbabb56b746787a18c461d.png";